import React, { FC, useContext } from 'react';
import { useLocale } from '../../../contexts/localeContext';
import { TranslationKeys } from '../../../contexts/TranslationKeys';
import notSelectedCheckbox from '../../../images/Not Selected.svg';
import selectedCheckbox from '../../../images/Selected.svg';
import TableCell from '../table-cell/table-cell';
import './table-head.css';
import { useFilter } from '../../../contexts/table/FilterContext';
import { useTable } from '../../../contexts/table/TableContext';

type Props = {
    columnDefinitions?: any[],
    selectAll?: boolean,
    onSelectAll?: (event: any) => void,
    onSort?: (id: any, direction: string) => void,
    allSelected?: boolean,
    customise?: boolean,
    onCustomise?: (event: any) => void,
}

const TableHead: FC<Props> = ({columnDefinitions = [], selectAll = false, onSelectAll = () => {}, onSort = () => {}, allSelected = false, customise = false, onCustomise = () => {}}) => {
    const { translate } = useLocale();
    const filterContext = useFilter();
    const tableContextProvider = useTable();

    return <thead className="bg-gray-bar border">
        <tr>
            {selectAll
                ? (
                    <TableCell
                        head
                        borderOptions="border-l border-t border-b"
                        alignmentOptions="w-1 pl-3 pr-0"
                        columnAttributes={{ active: true }}>
                        <div className="w-content interaction-container" onMouseDown={onSelectAll}>
                            <img data-cy="selectAllCheckbox" className="mt-px ml-px" src={allSelected ? selectedCheckbox : notSelectedCheckbox} alt="" />
                        </div>
                    </TableCell>
                )
                : tableContextProvider.onMoveUpOrDown ? <TableCell
                    head
                    borderOptions="border-l border-t border-b"
                    alignmentOptions="w-1 pl-3 pr-0"
                    columnAttributes={{ active: true }}>
                </TableCell> : null
            }
            {columnDefinitions
                .filter(item => item.active)
                .map((item, i, filteredArray) => (
                    <TableCell
                        key={`head-${i}`}
                        columnId={item.id}
                        head
                        columnAttributes={item}
                        isMultiSelect={tableContextProvider.isMultiSelect}
                        searchOnName={item.searchOnName}
                        direction={item.sortDirection}
                        onSort={onSort}
                        customise={filteredArray.length - 1 === i && customise}
                        onCustomise={onCustomise}
                        columnData={filterContext.lookup}
                        columnFilters={filterContext.filters}>
                        {translate.byKey(TranslationKeys[item.translationKey]) ? translate.byKey(TranslationKeys[item.translationKey]) : item.heading}
                    </TableCell>
                ))}
        </tr>
    </thead>
}

export default TableHead;

